const d3 = require("d3");
import csv from "../../data.csv";
window.onload = function () {
  console.log("Hi");

  d3.csv(csv).then(init);
};

function init(data) {
  let answers = [
    "Never",
    "Once or twice per month or less",
    "Once or twice per week",
    "3-4 times per week",
    "5-6 times per week",
    "7+ times per week",
  ];
  let answerSet = new Set(answers);
  const clean = data
    .map((d) =>
      answerSet.has(d.Q24) && answerSet.has(d.Q25)
        ? { expect: d.Q24, actual: d.Q25 }
        : null
    )
    .reduce((agg, curr) => {
      if (curr) agg.push(curr);
      return agg;
    }, []);
  let joined = d3.rollup(
    clean,
    (v) => ({ count: v.length, expect: v[0].expect, actual: v[0].actual }),
    (d) => `${d.expect} + ${d.actual}`
  );

  const width = d3.min([600, window.innerWidth]);
  const maxRadius = width / 20;
  const margin = { top: 20, right: maxRadius + 30, bottom: 80, left: 180 };
  const height = width - margin.top - margin.bottom;
  const boundedWidth = width - margin.left - margin.right;
  const boundedHeight = height - margin.top - margin.bottom;

  const xScale = d3.scalePoint().domain(answers).range([0, boundedWidth]);
  // .paddingInner(0.05)
  // .paddingOuter(0.5);
  const yScale = d3.scalePoint().domain(answers).range([boundedHeight, 0]);
  // .paddingInner(0.05)
  // .paddingOuter(0.5);
  const rScale = d3
    .scaleSqrt()
    .domain(d3.extent(Array.from(joined.values()).map((d) => d.count)))
    .range([10, maxRadius]);

  const colorScale = d3
    .scaleLog()
    .domain(d3.extent(Array.from(joined.values()).map((d) => d.count)))
    .range(["#f065a5", "#fdecf4"]);
  // .domain(answers);

  const el = d3.select("div.figure__graphic");
  const svg = el.append("svg").attr("width", width).attr("height", height);
  const g = svg
    .append("g")
    .attr("transform", `translate(${margin.left}, ${margin.top})`);
  console.log(joined);
  const circles = g
    .selectAll("g.grid")
    .data(d3.cross(answers, answers))
    // .data(Array.from(joined.values()))
    .join("g")
    .attr("class", "grid");
  circles
    .append("circle")
    .attr("cx", (d) => xScale(d[0]))
    .attr("cy", (d) => yScale(d[1]))
    .attr("r", (d) => {
      const key = `${d[0]} + ${d[1]}`;
      console.log(joined.get(key));
      if (joined.has(key)) return rScale(joined.get(key).count);
      return 1;
    })
    // .attr("width", xScale.bandwidth())
    // .attr("height", yScale.bandwidth())
    .attr("fill", (d) => {
      const key = `${d[0]} + ${d[1]}`;
      console.log(joined.get(key));
      if (joined.has(key)) return colorScale(joined.get(key).count);
      return "#FFFA";
    });
  circles
    .append("text")
    .attr("x", (d) => xScale(d[0]))
    .attr("y", (d) => yScale(d[1]))
    .attr("text-anchor", "middle")
    .attr("alignment-baseline", "middle")
    .text((d) => {
      const key = `${d[0]} + ${d[1]}`;
      if (joined.has(key)) return joined.get(key).count;
    });

  const yAxis = d3.axisLeft(yScale);
  g.append("g").attr("class", "axis yaxis").call(yAxis);
  const xAxis = d3.axisBottom(xScale);
  g.append("g")
    .attr("class", "axis xaxis")
    .call(xAxis)
    .attr("transform", `translate(0, ${boundedHeight + margin.top + 10})`);
  g.append("text")
    .attr("class", "axis-label")
    .attr("text-anchor", "middle")
    .text("Reality")
    .attr(
      "transform",
      `translate(${30 - margin.left}, ${ boundedHeight / 2})`
    );
  g.append("text")
    .attr("class", "axis-label")
    .attr("text-anchor", "middle")
    .text("Expectation")
    .attr(
      "transform",
      `translate(${boundedWidth / 2}, ${height - margin.top - 10})`
    );

  console.log(el);
}
